import { put, call } from "redux-saga/effects";
import {
    SAVE_COMPANYADDINFO_SUCESS, SAVE_COMPANYADDINFO_FAILED,
    GET_COMPANYADDINFO_SUCESS, GET_COMPANYADDINFO_FAILED,
    ADD_COMPANYADDINFO_SUCESS, ADD_COMPANYADDINFO_FAILED ,

      UPDATE_CORPORATE_SUCESS,    UPDATE_CORPORATE_FAILED,
   
     ADD_CORPORATE_SUCESS,    ADD_CORPORATE_FAILED,
    
} from "../actions/AddCorporate";
import { AddCorporateAPI } from "../../utils/api/AddCorporateAPI";

export function* getallCompanyAdditionalDetails(request: any) {
    try {
        const { data } = yield call(AddCorporateAPI.getallCompanyAdditionalDetails, request);

        yield put({
            type: GET_COMPANYADDINFO_SUCESS,
            payload: data
        });
    } catch (e) {
        yield put({ type: GET_COMPANYADDINFO_FAILED, payload: e.message });
    }
}
export function* saveCompanyAdditionalDetails(request: any) {
    //  alert("sagas");
    try {
        const result = yield call(AddCorporateAPI.saveCompanyAdditionalDetails, request.input);
        yield put({
            type: SAVE_COMPANYADDINFO_SUCESS,
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: SAVE_COMPANYADDINFO_FAILED, payload: e.message });
    }
}
export function* addCompanyDetails(request: any) {
    //  alert("sagas");
    try {
        const result = yield call(AddCorporateAPI.addCompanDetails, request.input);
        yield put({
            type: ADD_COMPANYADDINFO_SUCESS,
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: ADD_COMPANYADDINFO_FAILED, payload: e.message });
    }
}

export function* addCorporateDetails(request: any) {
    //  alert("sagas");
    try {
        const result = yield call(AddCorporateAPI.addCorporateDetails, request.input);
        yield put({
            type: ADD_CORPORATE_SUCESS,
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: ADD_CORPORATE_FAILED, payload: e.message });
    }
}

export function* updateCorporateDetail(request: any) {
    //  alert("sagas");
    try {
        const result = yield call(AddCorporateAPI.updateCorporateDetail, request.input);
        yield put({
            type: UPDATE_CORPORATE_SUCESS,
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: UPDATE_CORPORATE_FAILED, payload: e.message });
    }
}



 